<template>
    <div>
        <nav class="level">
            <div class="level-left">
                <div class="level-item">
                    <h2 class="title is-2">
                        {{ $meta.isStaff ? 'Admin' : '' }} Dashboard
                    </h2>
                </div>
            </div>

            <div
                v-if="$meta.isTenant && hasProperties && ($meta.features.tenants.fixflo || $meta.features.tenants.report_repair_contact_details)"
                class="level-right"
            >
                <div class="level-item is-block-mobile">
                    <b-button
                        v-if="propertiesCount === 1"
                        tag="router-link"
                        :to="{
                            name: 'tenancy-property-request-repair',
                            params: {
                                id: firstProperty.TenancyFK,
                            },
                        }"
                        rounded
                        :title="firstProperty.AddressString"
                    >
                        Request Repair
                        <b-icon
                            icon="arrow-right"
                            size="is-small"
                            class="ml-0"
                        />
                    </b-button>
                    <b-dropdown
                        v-if="propertiesCount > 1"
                        aria-role="list"
                        position="is-bottom-left"
                    >
                        <template #trigger="{ active }">
                            <b-button
                                label="Request Repair"
                                rounded
                                :icon-right="active ? 'arrow-down' : 'arrow-right'"
                            />
                        </template>
                        <b-dropdown-item
                            v-for="property in properties.Rows"
                            :key="property.PropertyPK"
                            aria-role="listitem"
                        >
                            <router-link
                                :to="{
                                    name: 'tenancy-property-request-repair',
                                    params: {
                                        id: property.TenancyFK,
                                    }
                                }"
                            >
                                {{ property.AddressString | truncate(60) }}
                            </router-link>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </nav>

        <hr />

        <div v-if="! $meta.isStaff && $meta.isTenant">
            <WelcomeMessage />

            <hr />
        </div>

        <div class="columns is-multiline is-variable is-6">
            <template v-if="! $meta.isStaff">
                <div
                    v-if="! $meta.isTenant"
                    class="column is-12-tablet is-3-desktop"
                >
                    <WelcomeMessage />
                </div>

                <div
                    v-if="$meta.isTenant && $meta.features.tenants.arrears"
                    class="column is-12-tablet is-3-desktop"
                >
                    <h4 class="title is-4">
                        Arrears
                    </h4>

                    <h6 class="subtitle is-6">
                        Being in arrears means you have unpaid rent.
                    </h6>

                    <ContactArrears />
                </div>

                <div class="column is-12-tablet is-3-desktop">
                    <h4 class="title is-4">
                        Notifications
                    </h4>

                    <h6 class="subtitle is-6">
                        Personal messages from the Agency for you.
                    </h6>

                    <Notifications />
                </div>

                <div
                    v-if="$meta.features.appointments"
                    class="column is-12-tablet is-3-desktop"
                >
                    <h4 class="title is-4">
                        Appointments
                    </h4>

                    <h6 class="subtitle is-6">
                        Upcoming <span v-if="$meta.isTenantOrLettingsApplicant">and recent</span> calendar appointments.
                    </h6>

                    <ContactAppointments />
                </div>
            </template>

            <div
                v-if="$meta.isStaff"
                class="column is-12-tablet is-4-desktop"
            >
                <h4 class="title is-4">
                    Welcome {{ $meta.userName }}
                </h4>

                <p>
                    You can impersonate a Web Portal user by
                    entering their full, unique email address below.
                </p>

                <UserSearch />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import UserSearch from '../components/UserSearch.vue';
import ContactAppointments from '../components/ContactAppointments.vue';
import WelcomeMessage from '../components/WelcomeMessage.vue';
import ContactArrears from '../components/ContactArrears.vue';
import HowToRentGuideModal from '../components/HowToRentGuideModal';
import Notifications from '../components/Notifications';

export default {
    components: {
        WelcomeMessage,
        ContactArrears,
        Notifications,
        UserSearch,
        ContactAppointments,
    },

    computed: {
        ...mapState('tenanciesProperties', [
            'properties',
        ]),
        ...mapGetters('tenanciesProperties', [
            'hasProperties',
            'propertiesCount',
            'firstProperty',
        ]),
    },

    mounted() {
        // reset property in store
        this.$store.dispatch('tenancyProperty/reset');

        if(this.$meta.isTenant) {
            // get properties for tenants, for "Repairs" button
            if(this.$meta.features.tenants.fixflo || this.$meta.features.tenants.report_repair_contact_details) {
                this.getRows();
            }

            // show "How to Rent" modal to tenants
            if(this.$meta.features.tenants.how_to_rent_guide && ! this.$meta.readHowToRentGuide) {
                this.showRentGuideModal();
            }
        }
    },

    methods: {
        getRows() {
            this.$store.dispatch('tenanciesProperties/getProperties', {
                limit: 30,
                page: 1,
            });
        },
        showRentGuideModal() {
            this.$buefy.modal.open({
                parent: this,
                component: HowToRentGuideModal,
                hasModalCard: true,
            });
        },
    },
};
</script>
